var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "#eeeeee",
      display: "block",
      zIndex: 1,
      position: "relative"
    },
    width: 1536,
    height: 1092,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1536 1092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(768,546) scale(1,1) translate(-768,-546)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg-0.9372338620805214",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3490b8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20dacd",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.9372338620805214)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "25s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "0s",
    values: "M0 0L 0 610.6006755247779Q 192 823.969005439129  384 785.0257181536247T 768 861.4333483147591T 1152 663.3255760999355T 1536 587.5129423031813L 1536 0 Z;M0 0L 0 861.4031392163852Q 192 934.0431033630293  384 882.2169227596037T 768 837.2845876911781T 1152 789.0623065351073T 1536 780.3231883927615L 1536 0 Z;M0 0L 0 803.2290416814736Q 192 862.9292669807339  384 839.8480120448746T 768 583.0888713438991T 1152 678.3483696172981T 1536 890.9274774344847L 1536 0 Z;M0 0L 0 610.6006755247779Q 192 823.969005439129  384 785.0257181536247T 768 861.4333483147591T 1152 663.3255760999355T 1536 587.5129423031813L 1536 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.9372338620805214)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "25s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-5s",
    values: "M0 0L 0 644.0749260947588Q 192 771.9535699015089  384 758.3426545845894T 768 572.5401988355501T 1152 813.5797842349219T 1536 706.8962373226168L 1536 0 Z;M0 0L 0 552.6026766854498Q 192 586.0344361669339  384 566.8307053615135T 768 539.4220479494923T 1152 620.6772471340686T 1536 648.1404068051863L 1536 0 Z;M0 0L 0 512.9334438286473Q 192 893.5780520509275  384 860.5227788270881T 768 737.8620460729553T 1152 549.091129556222T 1536 728.3809778366026L 1536 0 Z;M0 0L 0 644.0749260947588Q 192 771.9535699015089  384 758.3426545845894T 768 572.5401988355501T 1152 813.5797842349219T 1536 706.8962373226168L 1536 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.9372338620805214)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "25s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-10s",
    values: "M0 0L 0 585.6734830442214Q 192 916.318678185322  384 886.7203684641859T 768 644.138392878004T 1152 657.5837442490867T 1536 789.5364399260636L 1536 0 Z;M0 0L 0 711.5533477041348Q 192 805.3487481490464  384 766.8905634071007T 768 683.5756306898139T 1152 802.0496647568132T 1536 756.2089361398824L 1536 0 Z;M0 0L 0 637.0480442201113Q 192 716.9191745322072  384 701.811778851909T 768 582.6006637202355T 1152 510.80388675428026T 1536 893.071593653485L 1536 0 Z;M0 0L 0 585.6734830442214Q 192 916.318678185322  384 886.7203684641859T 768 644.138392878004T 1152 657.5837442490867T 1536 789.5364399260636L 1536 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.9372338620805214)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "25s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-15s",
    values: "M0 0L 0 722.8188920925695Q 192 808.7272775833599  384 776.1710251378847T 768 856.6491502543913T 1152 557.7591570328482T 1536 834.7185732829228L 1536 0 Z;M0 0L 0 622.3284696738277Q 192 616.900929647306  384 599.5566219685285T 768 862.802832656562T 1152 818.6921047742667T 1536 780.185333566605L 1536 0 Z;M0 0L 0 644.6895249958653Q 192 784.1868266781676  384 766.9025395088422T 768 579.9103624909113T 1152 888.1943814252145T 1536 691.7996528394432L 1536 0 Z;M0 0L 0 722.8188920925695Q 192 808.7272775833599  384 776.1710251378847T 768 856.6491502543913T 1152 557.7591570328482T 1536 834.7185732829228L 1536 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.9372338620805214)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "25s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-20s",
    values: "M0 0L 0 772.1280868092289Q 192 797.9297238361221  384 753.9325502545571T 768 642.6671794963816T 1152 889.6802788639609T 1536 706.8536527748528L 1536 0 Z;M0 0L 0 785.127413019401Q 192 762.8388646123901  384 749.0466987893708T 768 659.6205148096229T 1152 573.5575223833378T 1536 663.9173655532751L 1536 0 Z;M0 0L 0 836.140456763891Q 192 668.2775313874993  384 633.1715825065826T 768 682.0725160829004T 1152 636.2783600946282T 1536 556.8008488387482L 1536 0 Z;M0 0L 0 772.1280868092289Q 192 797.9297238361221  384 753.9325502545571T 768 642.6671794963816T 1152 889.6802788639609T 1536 706.8536527748528L 1536 0 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackWave);
export default __webpack_public_path__ + "static/media/backWave.51ace2cac0cd086eafd1891146f8b3d7.svg";
export { ForwardRef as ReactComponent };